'use client'

import { bullmqQueryClient } from '@repo/bullmq-admin-data-provider/query-client/query-client'
import { QueryClientProvider } from '@tanstack/react-query'
import { PropsWithChildren, useState } from 'react'

export default function MyQueryClientProvider({ children }: PropsWithChildren) {
  const [queryClient] = useState(bullmqQueryClient)

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
